var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-auto"},[_c('a',{staticClass:"button",attrs:{"href":_vm.getLoginUrl()}},[_vm._v(" Volver a entrar")])])])}
var staticRenderFns = []

export { render, staticRenderFns }